import React, { useState, useContext } from 'react'
import ReactDOM from 'react-dom'
import { NavLink } from 'react-router-dom'
import styled from 'styled-components'

const Context = React.createContext()

const useBreadcrumbContext = () => {
  const context = useContext(Context)

  if (!context) {
    throw new Error('No encuentra la ruta')
  }

  return context
}

const BreadcrumbProvider = ({ children }) => {
  const portalNodeState = useState()
  return <Context.Provider value={portalNodeState}>{children}</Context.Provider>
}

const BreadcrumbPortal = ({ children }) => {
  const [, setPortalNode] = useBreadcrumbContext()
  return (
    <nav aria-label='Breadcrumb'>
      <Items ref={setPortalNode} />
    </nav>
  )
}

const Items = styled.ol`
  margin: 0;
  padding-left: 0;
  list-style: none;
`

const Breadcrumb = ({ children, to, ...props }) => {
  const [portalNode] = useBreadcrumbContext()
  return portalNode
    ? ReactDOM.createPortal(
        <Item style={{ color: '#0ca39d' }} {...props}>
          <ItemLink to={to}>{children}</ItemLink>
        </Item>,
        portalNode,
      )
    : null
}

const Item = styled.li`
  display: inline;

  & + &::before {
    content: '';
    display: inline-block;
    transform: rotate(15deg);
    border-right: 1px solid currentColor;
    height: 1em;
    margin: 0 8px -0.2em;
  }
`

const ItemLink = styled(NavLink).attrs({ exact: true })`
  color: #0ca39d;
  text-decoration: none;
  border-bottom: 1px solid transparent;

  &:hover {
    color: #ed8b00;
  }

  &.active {
    border: none;
    color: #ed8b00;
  }
`
const HeaderBreadcrumb = styled.header`
  font-size: 18px;
  color: #0ca39d;
  text-transform: lowercase;
  padding-right: 15px;
  word-break: break-word;
  margin: 0;
  width: 900px;
`

export { BreadcrumbProvider, BreadcrumbPortal, Breadcrumb, HeaderBreadcrumb }
